import styled from 'styled-components';
import { Link } from 'react-router-dom';

/** Verde do selo "Ativo" no Figma (verde/500); sem token equivalente em colors.ts. */
const VERDE_ATIVO = '#10a875';

export const CardLink = styled(Link)`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  max-width: 100%;
  margin-top: 1rem;
  padding: 28px 32px;
  background: ${(props) => props.theme.$white};
  border: 1px solid ${VERDE_ATIVO};
  border-radius: 8px;
  text-decoration: none;

  &:hover {
    text-decoration: none;
  }

  /* o reset global zera o outline de *:focus; o foco por teclado precisa continuar visível */
  &:focus-visible {
    outline: 2px solid ${VERDE_ATIVO};
    outline-offset: 2px;
  }

  .logo {
    display: flex;
    align-items: center;
    gap: 8.71px;
    min-width: 0;
  }

  .logo-texto {
    max-width: 100%;
    height: auto;
    min-width: 0;
  }

  .badge-ativo {
    position: absolute;
    top: -10px;
    left: 50%;
    transform: translateX(-50%);
    padding: 2px 7px;
    border-radius: 100px;
    background: ${VERDE_ATIVO};
    color: ${(props) => props.theme.$white};
    font-size: 12px;
    font-weight: bold;
    line-height: normal;
    white-space: nowrap;
  }
`;
